module.exports = __webpack_public_path__ + "img/siegeworkshop_tech_Normal_ua.0be31330.webp";